/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgMainPip = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M2.667.667h10.666c1.134 0 2 .866 2 2v2.666c0 1.134-.866 2-2 2H2.667c-1.134 0-2-.866-2-2V2.667c0-1.134.866-2 2-2M13.333 6c.4 0 .667-.267.667-.667V2.667c0-.4-.267-.667-.667-.667H2.667c-.4 0-.667.267-.667.667v2.666c0 .4.267.667.667.667zm0 2.667H2.667c-1.134 0-2 .866-2 2v2.666c0 1.134.866 2 2 2h10.666c1.134 0 2-.866 2-2v-2.666c0-1.134-.866-2-2-2m0 5.333c.4 0 .667-.267.667-.667v-2.666c0-.4-.267-.667-.667-.667H2.667c-.4 0-.667.267-.667.667v2.666c0 .4.267.667.667.667z"
      clipRule="evenodd"
    />
    <mask
      id="main-pip_svg__a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M2.667.667h10.666c1.134 0 2 .866 2 2v2.666c0 1.134-.866 2-2 2H2.667c-1.134 0-2-.866-2-2V2.667c0-1.134.866-2 2-2M13.333 6c.4 0 .667-.267.667-.667V2.667c0-.4-.267-.667-.667-.667H2.667c-.4 0-.667.267-.667.667v2.666c0 .4.267.667.667.667zm0 2.667H2.667c-1.134 0-2 .866-2 2v2.666c0 1.134.866 2 2 2h10.666c1.134 0 2-.866 2-2v-2.666c0-1.134-.866-2-2-2m0 5.333c.4 0 .667-.267.667-.667v-2.666c0-.4-.267-.667-.667-.667H2.667c-.4 0-.667.267-.667.667v2.666c0 .4.267.667.667.667z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#main-pip_svg__a)">
      <path fill="currentColor" d="M0 0h16v16H0z" />
    </g>
  </svg>
)
export default SvgMainPip
